import { Reveal, Overline } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, EMAIL_MAILTO, SERVICE_AREAS, DIRECTOR } from "../lib/site";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="noise-dark scroll-mt-20 bg-lec-ink text-lec-bone">
    <div className="relative z-10 mx-auto max-w-7xl px-5 py-20 md:px-10 md:py-28">
      <Reveal>
        <Overline dark>Get in touch</Overline>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-semibold tracking-tight sm:text-5xl lg:text-6xl">
          Talk concrete with <span className="text-lec-green">Damien.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <a
            href={PHONE_TEL}
            data-testid="contact-phone-link"
            className="group block border-b border-lec-bone/15 pb-8"
          >
            <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-lec-bone/60">
              <Phone className="h-4 w-4 text-lec-green" /> Call or text
            </p>
            <p className="mt-3 font-display text-4xl font-semibold tracking-tight transition-colors duration-200 group-hover:text-lec-green sm:text-5xl lg:text-6xl">
              {PHONE_DISPLAY}
            </p>
          </a>
          <a
            href={EMAIL_MAILTO}
            data-testid="contact-email-link"
            className="group block border-b border-lec-bone/15 py-8"
          >
            <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-lec-bone/60">
              <Mail className="h-4 w-4 text-lec-green" /> Email
            </p>
            <p className="mt-3 break-all font-display text-xl font-semibold tracking-tight transition-colors duration-200 group-hover:text-lec-green sm:text-2xl lg:text-3xl">
              {EMAIL}
            </p>
          </a>
          <div className="py-8">
            <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-lec-bone/60">
              <Clock className="h-4 w-4 text-lec-green" /> Hours
            </p>
            <p className="mt-3 font-display text-xl font-semibold sm:text-2xl">Mon – Sat, 6am – 7pm</p>
            <p className="mt-1 text-sm text-lec-bone/60">Onsite consultations by appointment</p>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-5">
          <div className="border border-lec-bone/15 p-8" data-testid="service-area-card">
            <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-lec-bone/60">
              <MapPin className="h-4 w-4 text-lec-green" /> Service area
            </p>
            <p className="mt-4 text-sm leading-relaxed text-lec-bone/70">
              Based in the southern suburbs and pouring right across the Perth metro:
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {SERVICE_AREAS.map((s) => (
                <span
                  key={s}
                  className="border border-lec-bone/20 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.15em] text-lec-bone/80"
                >
                  {s}
                </span>
              ))}
            </div>
            <p className="mt-6 text-sm text-lec-bone/70">
              Director: <span className="font-semibold text-lec-bone">{DIRECTOR}</span>
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
